import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Logout} from "@khan/auth-logout";

import PageRoot from "#app-shell-package/page-root.tsx";
import SimplifiedPageHeader from "#auth/components/simplified-page-header.tsx";

function LogoutPage() {
    return (
        <PageRoot settings={{header: false}}>
            <SimplifiedPageHeader backgroundColor="white" />
            <View style={styles.container}>
                <Logout />
            </View>
        </PageRoot>
    );
}

const styles = StyleSheet.create({
    container: {
        paddingTop: spacing.xLarge_32,
    },
});

export default LogoutPage;
